"use strict";

define('view/study.detail',['require','exports','module','underscore','marionette','config','uikit/uikit','view/attachmentsWithDocStore.tab','view/flag.selection.container','model/flag','model/organization','model/assignment','libs/color','libs/route.helper','libs/format/date','libs/format/empty','templates','langs'],function (require, exports, module) {
  var _ = require('underscore'),
    Mn = require('marionette'),
    config = require('config'),
    UIKit = require('uikit/uikit'),
    AttachmentsTab = require('view/attachmentsWithDocStore.tab'),
    FlagSelectionContainer = require('view/flag.selection.container'),
    Flag = require('model/flag'),
    OrganizationModel = require('model/organization'),
    OrgChangeModel = require('model/assignment'),
    Color = require('libs/color'),
    RouteHelper = require('libs/route.helper'),
    dateFormatter = require('libs/format/date'),
    emptyFormatter = require('libs/format/empty'),
    Templates = require('templates'),
    langs = require('langs');
  var linkTextFormatter = function linkTextFormatter(v) {
    return new Handlebars.SafeString('<span class="link">' + v + '</span>');
  };
  var STUDY_CONTACTS_COLUMNS = [{
    text: 'Team Member',
    data: 'displayName'
  }, {
    text: 'Role',
    data: 'assignmentType.displayName'
  }, {
    text: 'Number',
    data: 'primaryPhone'
  }, {
    text: 'Email',
    data: 'primaryEmail'
  }];
  var LINKED_PROPOSAL_COLUMNS = [{
    text: 'Proposal #',
    data: 'PROPOSALNUMBER',
    formatter: linkTextFormatter
  }, {
    text: 'Lead PI',
    data: 'LEADFULLNAME'
  }, {
    text: 'Status',
    data: 'PROPOSALSTATUS'
  }, {
    text: 'Begin Date',
    data: 'PROJECTBEGINDATE',
    formatter: dateFormatter(config.dateFormat)
  }, {
    text: 'End Date',
    data: 'PROJECTENDDATE',
    formatter: dateFormatter(config.dateFormat)
  }];
  var StudyDetailView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    template: Templates.IRB['study.detail'],
    options: {
      app: null,
      state: null,
      activeDocuments: null,
      attachments: null,
      documents: null,
      availableFlags: null,
      canModifyFlags: false,
      assignments: null,
      personAssignments: null,
      titleField: null,
      pdfBtn: null,
      deleteBtn: null,
      linkProposalBtn: null,
      useTopSegmentHeader: true,
      hideTopSegmentHeaderFromScreens: true,
      topSegmentHeaderText: '',
      useBottomSegmentHeader: true,
      hideBottomSegmentHeaderFromScreens: true,
      bottomSegmentHeaderText: '',
      titleFormId: 'studyTitle'
    },
    update: {
      app: false,
      state: false,
      activeDocuments: false,
      documents: false,
      assignments: false,
      personAssignments: false,
      titleField: false,
      pdfBtn: false,
      deleteBtn: false,
      topSegmentHeaderText: true,
      bottomSegmentHeaderText: true,
      titleFormId: true
    },
    modelEvents: {
      'change:id': 'updateOnSync',
      sync: 'updateStatusColor'
    },
    ui: {
      bottomTabs: '.bottom-tabs'
    },
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this._setupComponentHeaders();
      this._setupForm();
      this._setupTables();
      this._setupActions();
      this._setupModelListeners();
      this._setupEditableFieldListeners();
      this._updateEditingProperties();
      this._flatOrgsCollection = new OrganizationModel.FlatOrgsCollection();
    },
    onComponentsRender: function onComponentsRender() {
      this.titleField.$el.css({
        'font-size': '16px'
      });
      this.titleField.$el.css({
        'margin-left': this.titleField.editable ? '-1em' : 'inherit',
        'margin-top': this.titleField.editable ? '-0.67861em' : '-0.2em'
      });
      this.label.$el.parent().css({
        'vertical-align': 'top'
      });
    },
    updateOnSync: function updateOnSync() {
      this._updateEditingProperties();
    },
    updateStatusColor: function updateStatusColor() {
      var status = this.model.get('status') || this.model.get('legacyStatus');
      this.statusText.text = status;
      this.statusText.color = Color.Status(status);
    },
    _setupComponentHeaders: function _setupComponentHeaders() {
      this.topSegmentHeaderText = langs.phrase('StudiesPage.Details.TopSegmentHeader');
      this.bottomSegmentHeaderText = langs.phrase('StudiesPage.Details.BottomSegmentHeader');
    },
    _setupForm: function _setupForm() {
      var parentPageView = this;
      var OrgEditableField = UIKit.EditableField.extend({
        className: UIKit.EditableField.prototype.className + ' org-editable-field',
        parentPageView: parentPageView,
        onBeforeRender: function onBeforeRender(view, newValue, oldValue) {
          var textViewModel = view.textView.model;
          if (textViewModel && !textViewModel.get('title')) {
            textViewModel.set({
              title: 'N/A'
            });
          }
        },
        onEndEdit: function onEndEdit() {
          this.input.value = null;
        },
        onConfirm: function onConfirm() {
          var studyId = this.parentPageView.getOption('state').get('studyId');
          var orgAssignmentModel = this.parentPageView.assignments.getByAssignmentTypeDescription('IRB_ORGANIZATION').first();
          var orgChangeModel = this.model;
          var self = this;
          if (!this.input.value) {
            this.editing = false;
            return;
          }
          this.confirmButton.loading = true;
          Promise["try"](function () {
            var orgAssignmentTypeId = orgAssignmentModel && orgAssignmentModel.has('assignmentType') ? orgAssignmentModel.get('assignmentType').get('id') : -1;
            return orgChangeModel.requestChangeOrganization(studyId, orgAssignmentTypeId);
          }).then(function (resp) {
            var data;
            if (resp.valid) {
              data = resp.data[0];
              if (!orgAssignmentModel) {
                self.parentPageView.assignments.add([data]);
              } else {
                orgAssignmentModel.set(data);
              }
              self.parentPageView.setOrganizationText();
            } else {
              throw new Error(resp.error.message);
            }
          })["finally"](function () {
            self.editing = false;
            self.confirmButton.loading = false;
          });
        }
      });
      var self = this,
        approvalDateText = new UIKit.Text({
          model: this.model,
          bindings: {
            text: 'approvalDate'
          },
          formatter: dateFormatter(config.dateFormat, 'N/A')
        }),
        statusText = this.statusText,
        expirationDateText = new UIKit.Text({
          model: this.model,
          bindings: {
            text: 'expirationDate'
          },
          formatter: dateFormatter(config.dateFormat, 'N/A')
        }),
        adminCheckinDateText = new UIKit.Text({
          model: this.model,
          bindings: {
            text: 'adminCheckinDate'
          },
          formatter: dateFormatter(config.dateFormat, 'N/A')
        }),
        closedDateText = new UIKit.Text({
          model: this.model,
          bindings: {
            text: 'finalizedDate'
          },
          formatter: dateFormatter(config.dateFormat, 'N/A')
        }),
        sponsorsText = new UIKit.Text({
          formatter: emptyFormatter('N/A')
        }),
        emptyActiveText = new UIKit.Text({
          name: 'emptyActiveText',
          formatter: emptyFormatter('N/A'),
          visible: false
        }),
        currentPolicyText = new UIKit.Text({
          model: this.model,
          bindings: {
            text: 'policyDescription'
          }
        }),
        activeSubmissions = new UIKit.List({
          name: 'activeSubmissionList',
          className: 'ui bulleted list details-list-noglyph',
          bulleted: true,
          collection: this.activeDocuments,
          childViewOptions: {
            bindings: {
              text: 'templateType'
            },
            linkFormatter: function linkFormatter(model) {
              return RouteHelper.createLink('submission:detail', model, {
                documentId: 'id',
                studyId: 'studyId'
              });
            }
          }
        });
      statusText.model = this.model;
      this.changeOrgView = new OrgEditableField({
        active: true,
        editable: false,
        model: new OrgChangeModel({
          title: 'N/A'
        }),
        text: 'Organization:',
        textBinding: 'title',
        input: new UIKit.Select({
          placeholder: 'select organization',
          ajaxURL: '/rs/api/org/paged',
          dataType: 'json',
          ajaxResultProcessor: function ajaxResultProcessor(data) {
            var formattedData = data.data.map(function (element) {
              return {
                id: element.id,
                text: element.title
              };
            });
            return {
              results: formattedData,
              pagination: {
                more: !data.page.lastPage
              }
            };
          }
        })
      });
      this.titleField = new UIKit.EditableField({
        disableButton: true,
        fluid: true,
        model: this.model,
        input: new UIKit.Input({
          attributes: {
            id: this.getOption('titleFormId')
          },
          name: 'title',
          placeholder: 'Enter study title here',
          icon: ' ',
          iconRight: true
        }),
        valueBinding: 'title',
        width: 16
      });
      this.titleForm.model = this.model;
      this.titleForm.add(this.titleField);
      this.label.model = this.model;
      this.label.bindings.text = 'label';
      this.studyForm.addGroup().addField({
        width: 6
      }).addGroup({
        size: 3
      }).addField({
        text: 'Approval Date:'
      }, approvalDateText).getOption('parent').addField({
        text: 'Expiration Date:'
      }, expirationDateText).getOption('parent').addField({}, this.changeOrgView).getOption('parent').getOption('parent').addGroup({
        size: 3
      }).addField({
        text: 'Admin Check-In Date: '
      }, adminCheckinDateText).getOption('parent').addField({
        text: 'Closed Date: '
      }, closedDateText).getOption('parent').addField({
        text: 'Current Policy'
      }, currentPolicyText).getOption('parent').getOption('parent').getOption('parent').addField({
        width: 2
      }).addGroup({
        size: 2
      }).addField({
        text: 'Active Submissions:'
      }, activeSubmissions).add(emptyActiveText).addField({
        text: 'Sponsors: '
      }, sponsorsText);
      var lastNonEmptyStudyFormField = this.studyForm.getField(this.studyForm['activeSubmissionList']);
      if (this.getOption('canModifyFlags')) {
        var selectedPopulationsFlags = new UIKit.Text({
          name: 'selectedPopulationsFlagsList'
        });
        var selectedAdditionalFlags = new UIKit.Text({
          name: 'selectedAdditionalFlagsList'
        });
        lastNonEmptyStudyFormField.parent().parent().parent().addField({
          width: 6
        }).addGroup().addField({
          text: 'Population Flags:'
        }, selectedPopulationsFlags).getOption('parent').addField({
          text: 'Additional Flags:'
        }, selectedAdditionalFlags);
      }
      this.attachmentsTabView = new AttachmentsTab({
        canDelete: this.getOption('canModifyStudy'),
        canUpload: this.getOption('canModifyStudy'),
        uploadHandler: this.getOption('uploadHandler'),
        showStampIndicators: false,
        tableOptions: {
          collection: this.getOption('attachments'),
          ariaLabel: 'Attachments'
        }
      });
      this.tabs.tabListAriaLabel = langs.phrase('StudiesPage.Details.BottomTabs.ARIALabel');
      this.studyContactsTable = new UIKit.Table({
        basic: true,
        borderless: true,
        ariaLabel: 'Key Contacts'
      });
      this.linkedProposalsTable = new UIKit.Table({
        basic: true,
        borderless: true,
        ariaLabel: 'Linked Proposals'
      });
      this.tabs.add('Key Contacts', this.studyContactsTable, function (tab) {
        tab.fitted = true;
        self.studyContactsTab = tab;
      }).add('Attachments', this.attachmentsTabView, function (tab) {
        tab.fitted = true;
        tab.$el.css('border', '0');
        self.studyAttachmentsTab = tab;
      }).add('Linked Proposals', this.linkedProposalsTable, function (tab) {
        tab.menuItem.visible = false;
        tab.fitted = true;
        self.linkedProposalsTab = tab;
      });
      if (this.getOption('canModifyFlags')) {
        this.flagsContainer = new FlagSelectionContainer({
          availableFlags: this.getOption('availableFlags'),
          model: this.model
        });
        this.tabs.add('Flags', this.flagsContainer, function (tab) {
          tab.fitted = true;
          self.flagsTab = tab;
        });
      }
      if (this.model.isNew()) {
        statusText.visible = false;
      }
      this.listenTo(this.assignments, 'sync', function () {
        this.setOrganizationText();
        sponsorsText.text = this.assignments.getPropByFinderType('sponsor', 'sponsor.name');
      });
    },
    setOrganizationText: function setOrganizationText() {
      var orgText = this.assignments.getPropByFinderType('organization', 'organization.title');
      this.changeOrgView.model.set({
        title: orgText
      });
    },
    _setupActions: function _setupActions() {
      var field = new UIKit.Form.Field();
      this.pdfBtn = new UIKit.Button({
        attributes: {
          role: 'button',
          'aria-label': langs.phrase('StudiesPage.Button.PDF.ARIALabel')
        },
        text: 'PDF',
        icon: 'file pdf outline',
        disabled: true
      });
      this.deleteBtn = new UIKit.Button({
        attributes: {
          role: 'button',
          'aria-label': langs.phrase('StudiesPage.Button.Delete.ARIALabel')
        },
        text: 'Delete',
        icon: 'trash',
        disabled: true
      });
      this.linkProposalBtn = new UIKit.Button({
        attributes: {
          role: 'button',
          'aria-label': langs.phrase('StudiesPage.Button.Link.ARIALabel')
        },
        text: 'Link Proposal',
        icon: 'linkify',
        disabled: true,
        visible: false
      });
      this.listenTo(this.pdfBtn, 'press', function () {
        var studyService = this.app.service('study');
        studyService.createPDF(this.model, this.app);
      });
      this.listenTo(this.deleteBtn, 'press', function () {
        var self = this;
        this.app.request('modal', {
          type: 'CONFIRM_DESTROY',
          state: this.state,
          name: this.model.get('label')
        }, {
          ariaControlsId: 'studyDetails'
        }).on('destroy:model', function () {
          self.model.destroy({
            wait: true
          }).promise()["finally"](app.request('dimmer'));
        });
      });
      field.add(this.pdfBtn);
      field.add(this.deleteBtn);
      field.add(this.linkProposalBtn);
      this.buttonForm.add(field);
    },
    _setupTables: function _setupTables() {
      this.studyContactsTable.columns.add(STUDY_CONTACTS_COLUMNS);
      this.studyContactsTable.compact = true;
      this.studyContactsTable.padded = false;
      this.studyContactsTable.sortable = false;
      this.studyContactsTable.emptyText = 'No Key Study Contacts.';
      this.linkedProposalsTable.columns.add(LINKED_PROPOSAL_COLUMNS);
      this.linkedProposalsTable.compact = true;
      this.linkedProposalsTable.padded = false;
      this.linkedProposalsTable.sortable = false;
      this.linkedProposalsTable.emptyText = 'No Linked Proposals.';
    },
    _setupEditableFieldListeners: function _setupEditableFieldListeners() {
      this.listenTo(this.titleField, 'confirm', function () {
        this.titleForm.clearErrors();
        this.showInputLoading();
        if (this.model.isNew()) {
          this.trigger('create:study');
        } else {
          this.trigger('edit:study');
        }
      }).listenTo(this.titleField, 'close', function () {
        if (this.model.isNew()) {
          this.titleField.editing = true;
        }
        this.titleForm.clearErrors();
      });
    },
    _setupModelListeners: function _setupModelListeners() {
      this.listenTo(this.documents, 'sync', function () {
        this._updateDocumentProperties();
      }).listenTo(this.activeDocuments, 'sync', function () {
        this._updateActiveDocumentsView();
      }).listenToOnce(this.model, 'sync', function () {
        this.statusText.visible = true;
      }).listenTo(this.model, 'sync', this._updateFlagsSummary).listenTo(this.model, 'validated', this.hideInputLoading).listenTo(this.model, 'sync', this.hideInputLoading);
    },
    showInputLoading: function showInputLoading() {
      this.titleForm.title.loading = true;
      this.titleField.closeOnBlur = false;
    },
    hideInputLoading: function hideInputLoading() {
      if (this._isRendered) {
        this.titleForm.title.loading = false;
      }
      this.titleField.closeOnBlur = true;
    },
    _updateDocumentProperties: function _updateDocumentProperties() {
      this.deleteBtn.disabled = !!this.documents.length;
    },
    _updateActiveDocumentsView: function _updateActiveDocumentsView() {
      this.studyForm.emptyActiveText.visible = !this.activeDocuments.length;
      this.studyForm.activeSubmissionList.visible = !!this.activeDocuments.length;
    },
    _updateFlagsSummary: function _updateFlagsSummary() {
      if (this.getOption('canModifyFlags')) {
        var selectedFlagsCollection = new Flag.Collection(this.model.get('flags'));
        if (this.selectedPopulationsCollection && this.selectedAdditionalsCollection) {
          this.selectedPopulationsCollection.reset(selectedFlagsCollection.models);
          this.selectedPopulationsCollection.isolateCollectionToCategory(Flag.POPULATION);
          this.selectedAdditionalsCollection.reset(selectedFlagsCollection.models);
          this.selectedAdditionalsCollection.isolateCollectionToCategory(Flag.ADDITIONAL);
        } else {
          this.selectedPopulationsCollection = selectedFlagsCollection.clone();
          this.selectedPopulationsCollection.isolateCollectionToCategory(Flag.POPULATION);
          this.selectedAdditionalsCollection = selectedFlagsCollection.clone();
          this.selectedAdditionalsCollection.isolateCollectionToCategory(Flag.ADDITIONAL);
        }
        var selectedPopulations = this.selectedPopulationsCollection.map(Flag.getDescription);
        var selectedAdditionals = this.selectedAdditionalsCollection.map(Flag.getDescription);
        this.studyForm.selectedPopulationsFlagsList.text = selectedPopulations.join(', ');
        this.studyForm.selectedAdditionalFlagsList.text = selectedAdditionals.join(', ');
      }
    },
    _updateEditingProperties: function _updateEditingProperties() {
      if (this.model.isNew()) {
        this.titleField.closeOnBlur = false;
        this.titleField.editing = true;
        this.titleField.saveOnBlur = true;
      } else {
        this.titleField.closeOnBlur = true;
        this.titleField.editing = false;
        this.titleField.saveOnBlur = false;
        this.pdfBtn.disabled = false;
        this.linkProposalBtn.disabled = false;
      }
    }
  });
  module.exports = StudyDetailView;
});

